package music.jammers.client.shared.component

import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.ReadOnlyComposable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import limasoul.client.shared.generated.resources.Res
import limasoul.client.shared.generated.resources.ic_add
import limasoul.client.shared.generated.resources.ic_bass
import limasoul.client.shared.generated.resources.ic_drums
import limasoul.client.shared.generated.resources.ic_guitar
import limasoul.client.shared.generated.resources.ic_keys
import limasoul.client.shared.generated.resources.ic_mic
import music.jammers.shared.instrument.domain.model.InstrumentType
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun AddInstrumentImage(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Box(
        modifier = Modifier
            .size(58.dp)
    ) {
        val boxModifier = modifier
            .size(50.dp)
            .clip(shape = CircleShape)
            .clickable(onClick = onClick)
            .border(
                width = 1.dp,
                color = MaterialTheme.colorScheme.primary,
                shape = CircleShape,
            )

        Column {
            Spacer(modifier = Modifier.size(8.dp))

            Box(
                modifier = boxModifier,
            ) {
                Icon(
                    painter = painterResource(Res.drawable.ic_add),
                    tint = MaterialTheme.colorScheme.primary,
                    contentDescription = "Instrument",
                    modifier = Modifier.align(Alignment.Center),
                )
            }
        }
    }
}

data class Instrument(
    val icon: DrawableResource,
    val type: InstrumentType,
) {

    val iconColor: Color
        @Composable
        @ReadOnlyComposable
        get() = MaterialTheme.colorScheme.onSecondaryContainer
}

internal fun getInstrumentByType(type: InstrumentType): Instrument =
    when (type) {
        InstrumentType.VOCAL -> Instrument(Res.drawable.ic_mic, type)
        InstrumentType.GUITAR -> Instrument(Res.drawable.ic_guitar, type)
        InstrumentType.BASS   -> Instrument(Res.drawable.ic_bass, type)
        InstrumentType.PIANO -> Instrument(Res.drawable.ic_keys, type)
        InstrumentType.DRUMS  -> Instrument(Res.drawable.ic_drums, type)
    }